module.exports = __webpack_public_path__ + "public/SiteIcons/calendar.svg?f1291d32";